import { get, post } from '../../common/ApiClient';
import { AddressResponse } from '../types/Address';
import { FamilyCodeInfoResponse, FamilyActivationResponse } from '../types/CodeInfo';
import { Address } from '../types/Address';

export const getAddresses = async (email: string): Promise<AddressResponse> => {
  const { data } = await get<AddressResponse>(`/users/addresses`, false, {}, { email });

  return data;
};

export const getCodeInfo = async (code: string): Promise<FamilyCodeInfoResponse> => {
  const endpoint = '/code/check';
  const { data } = await get<any>(endpoint, false, {}, { code });
  return data;
};

export const activateCode = async (activationCode: string): Promise<FamilyActivationResponse> => {
  try {
    const formData = new FormData();
    formData.append('code', activationCode);

    const endpoint = '/code/activate';

    const activationResponse = await post<FamilyActivationResponse>(endpoint, true, formData, {}, { isJson: true });

    return activationResponse.data;
  } catch (error) {
    throw error;
  }
};

export const saveAddress = async (address: Address): Promise<AddressResponse> => {
  try {
    let formData = new FormData();

    formData.append('email', address.email);
    formData.append('type', address.type);
    formData.append('company_name', address.company_name);
    formData.append('first_name', address.first_name);
    formData.append('last_name', address.last_name);
    formData.append('address', address.address);
    formData.append('number', address.number);
    formData.append('zip', address.zip);
    formData.append('city', address.city);
    formData.append('phone_number', address.phone_number);
    formData.append('country', address.country_iso);
    formData.append('company_id', address.company_id);
    formData.append('tax_id', address.tax_id);
    formData.append('vat_id', address.vat_id);

    const response = await post<AddressResponse>('/users/address', false, formData);

    return response.data;
  } catch (error) {
    throw error;
  }
};
